export enum PageSizes {
  PAGINATED_COLLECTION_APPLICATIONS_SIZE = 20,
  PAGINATED_BLUEPRINTS_SIZE = 20,
  PAGINATED_APPLICATION_RELATED_APPS_SIZE = 6,
  PAGINATED_APPLICATION_REVIEWS_SIZE = 5,
  PAGINATED_APPLICATIONS_SECTION_SIZE = 6,
  PAGINATED_APPLICATIONS_EXPANDED_SIZE = 20,
  PAGINATED_APPLICATIONS_QUICK_SEARCH_SIZE = 5,
}
